<footer class="footer-page" id="footer-page-banrep">
      <div class="row">
            <div class="columns medium-1 moneda-footer nopadding">
                  <p><img alt="" data-entity-type="file" data-entity-uuid="a86350fb-5eab-416e-b085-bfc11bbeab77"
                              height="40"
                              src="https://d1b4gd4m8561gs.cloudfront.net/sites/default/files/logolinea-brcblanco-footer.svg"
                              width="40" /></p>
            </div>
            <div class="medium-3 columns menu-banrep">
                  <p><a href="https://www.banrep.gov.co/es" target="_blank">PORTAL CORPORATIVO</a> <a
                              href="https://investiga.banrep.gov.co/es" target="_blank">PORTAL DE INVESTIGACIONES
                              ECONÓMICAS</a><a href="https://www.banrepcultural.org/" target="_blank">PORTAL DE LA
                              ACTIVIDAD CULTURAL</a><a href="https://www.banrepcultural.org/actividad-musical"
                              target="_blank">ACTIVIDAD MUSICAL</a><a href="https://repositorio.banrep.gov.co"
                              target="_blank">REPOSITORIO INSTITUCIONAL</a> <a
                              href="https://www.banrepcultural.org/biblioteca-virtual" target="_blank">BIBLIOTECA
                              VIRTUAL</a> <a href="https://www.redinvestigadores.org/" target="_blank">RED DE
                              INVESTIGADORES</a></p>

                  <div id="redes-footer">
                        <div><a class="facebook" href="https://www.facebook.com/BancoRepublica"
                                    target="_blank">Facebook</a> <a class="twitter"
                                    href="https://twitter.com/bancorepublica" target="_blank">Twitter</a> <a
                                    class="instagram" href="https://www.instagram.com/bancorepublicacolombia"
                                    target="_blank">Instagram</a> <a class="youtube"
                                    href="https://www.youtube.com/BancoRepublica" target="_blank">Youtube</a> <a
                                    class="linkedin" href="https://co.linkedin.com/company/bancorepublica"
                                    target="_blank">Linkedin</a> <a class="flickr"
                                    href="https://www.flickr.com/photos/bancodelarepublica-colombia/"
                                    target="_blank">Flickr</a></div>
                  </div>

                  <p><a href="https://www.banrep.gov.co/es/donde-estamos" target="_blank">BANCO DE LA REPÚBLICA |
                              COLOMBIA<br />
                              Carrera 7 #14-78 (Edificio Principal)<br />
                              Bogotá, D. C., Colombia</a></p>
            </div>
            <div class="columns medium-4">
                  <h2 class="block-title">Información de interés y ayuda</h2>
                  <p><a href="https://www.banrep.gov.co/es/calendario-eventos" target="_blank">Calendario económico y
                              feriados
                              bancarios</a><br><a
                              href="https://suameca.banrep.gov.co/estadisticas-economicas/#/calendario">Calendario de
                              publicación
                              de estadísticas</a><br><a
                              href="https://www.banrep.gov.co/es/estadisticas/informacion-mercados-tiempo-real"
                              target="_blank">Información de los mercados en tiempo real</a><br><a
                              href="https://www.banrep.gov.co/es/blog" target="_blank">Blog BanRep</a><br><a
                              href="https://www.banrep.gov.co/es/podcast" target="_blank">Pódcast Cuentas y
                              cuentos</a><br><a href="https://www.banrep.gov.co/es/glosario"
                              target="_blank">Glosario</a><br><a
                              href="https://www.banrep.gov.co/es/wiki-preguntas-frecuentes" target="_blank">Preguntas
                              frecuentes</a><br><a href="https://www.banrep.gov.co/es/noticias" target="_blank">Prensa
                              digital</a><a href="https://www.banrep.gov.co/es/trabaje-con-nosotros"
                              target="_blank">Trabaje con
                              nosotros</a><br></p>
            </div>
            <div class="columns medium-4">
                  <h2 class="block-title">Datos de contacto</h2>
                  <p><a href="https://www.banrep.gov.co/es/donde-estamos" target="_blank">Directorio de Bogotá,
                              sucursales y
                              centros culturales</a><br />
                        <a href="https://www.banrep.gov.co/es/transparencia/atencion-ciudadania"
                              target="_blank">Registre su
                              PQR</a><br />
                        <a href="https://www.banrep.gov.co/es/atencion-exclusiva-inversionistas-y-analistas-mercado-nuevo"
                              target="_blank">Atención a inversionistas</a>
                  </p>

                  <p><a href="https://www.banrep.gov.co/es/aviso-legal" target="_blank">Términos y condiciones</a><br />
                        <a href="https://www.banrep.gov.co/es/proteccion-datos-personales" target="_blank">Política de
                              privacidad y tratamiento de datos personales</a><br />
                        <a href="https://www.banrep.gov.co/es/aviso-legal#autor" target="_blank">Políticas de derechos
                              de autor
                              y Propiedad intelectual</a><br />
                        <a href="https://www.banrep.gov.co/es/politicas-de-seguridad-de-la-informacion"
                              target="_blank">Políticas de seguridad de la información</a>
                  </p>
            </div>
      </div>
</footer>